import { SpinnerModule } from './shared/spinner/spinner.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { AppComponent } from './app.component';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppConfigProvider } from './app-config.provider';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr-CA';
//import { AppSeeder } from './tools/seeder/app.seeder';
import { ContentFactory, SchemasFactory } from './services';
import { interval } from 'rxjs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
//import { APP_BASE_HREF } from '@angular/common';

registerLocaleData(localeFr, 'fr-CA');
/*
export function appSeeding(appConfigProvider: AppConfigProvider, httpClient: HttpClient): Promise<boolean> {

  const contentFactory = new ContentFactory(httpClient, appConfigProvider);
  const schemasFactory = new SchemasFactory(httpClient, appConfigProvider, contentFactory);
  const appSeeder = new AppSeeder(schemasFactory, contentFactory, appConfigProvider);

  if (!appConfigProvider.squidexDefaultSchemaIsCreated()) {

    return appSeeder.initializeSquidexApplication()
      .toPromise()
      .then(s => {
        const seconds = interval(30000);
        seconds.subscribe();
        appSeeder.generateDefaultContents(appConfigProvider.getDefaultCulture());
        return true;
      });

  } else {
    appSeeder.consoleJSONResumeOfCurrentApp();
    return Promise.resolve(true);
  }
}*/

export function appConfigLoader(appConfigProvider: AppConfigProvider, httpClient: HttpClient) {
  return () => appConfigProvider.loadConfig().then(() => {
    //return appSeeding(appConfigProvider, httpClient).then(() => {
    //  httpClient.get('api/o/config/seeded').subscribe();
    //});
  });
}
// AoT requires an exported function for factories
export function httpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    CommonModule,
    ModalModule.forRoot(),
    FontAwesomeModule,
    HttpClientModule,
    FormsModule,
    AppRoutingModule,
    SpinnerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    TabsModule.forRoot(),
    FontAwesomeModule
  ],
  providers: [
    //{ provide: APP_BASE_HREF, useValue: '/client-admin' },
    AppConfigProvider,
    {
      provide: APP_INITIALIZER,
      useFactory: appConfigLoader,
      multi: true,
      deps: [AppConfigProvider, HttpClient]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    DatePipe
  ],
  bootstrap: [AppComponent]
})

export class AppModule {}
